<template lang="pug">
article(v-if="isHome")
	transition(name="fade")
		Home(v-if="isHome")
article(v-else-if="isStandings")
	transition(name="fade")
		Standings(v-if="isStandings")
article(v-else-if="!isHome")
	transition(name="fade")
		Live(v-if="!isHome")
</template>

<style lang="sass">

@import "@/styles/general.sass"
@import "@/styles/basecamp.sass"
@import "@/styles/buttons.sass"
@import "@/styles/table.sass"


</style>

<script>

import Live from "@/views/Live.vue"
import Home from "@/views/Home.vue"
import Standings from "@/views/Standings.vue"

export default {
	name: "App",
	metaInfo() {
		return {
			title: "ACB Live",
			meta: [
				{
					name: 'description',
					content: this.$i18n.t('meta_description')
				}
			]
		}
	},
	computed: {
		isHome() {
			return this.$route.name.split('.').includes('home')
		},
		isStandings() {
			return this.$route.name.split('.').includes('standings')
		},
		lang() {
			return this.$store.state.general.lang
		},
	},
	components: {
		Live,
		Home,
		Standings,
	},
	watch: {
		lang(newValue) {
			this.$i18n.locale = newValue
			this.$route.params.lang = newValue
		}
	},
	created() {
		if (this.$route.params.id_match)
			this.$store.dispatch('match/loadMatchData', this.$route.params.id_match)
		this.$store.commit('general/setBrowser', navigator.userAgent.toLowerCase())
		this.$i18n.locale = this.$route.path.split('/')[1]
		this.$route.params.lang = this.$route.path.split('/')[1]
		this.$store.commit("general/setLang", this.$i18n.locale)

		if (this.$route.query.app != null) {
			this.$store.commit("general/setIsApp", true)
			if (this.$route.query.match) {
				this.$store.commit("general/setNav", false);
			} else {
				this.$store.commit("general/setNav", true);
			}
		}
		if (this.$route.query.prematch != null) {
			this.$store.commit("general/setNavigationPrematch", this.$route.query.prematch)
		}
	},
}

</script>